export default {
  MUTILPLE_ADD_ON_LOADED: 'shared:mutliple-add-on:loaded',
  MUTILPLE_ADD_ON_SHOW: 'shared:mutliple-add-on:show',
  ADVANCED_REPORTING_ADD_ON_SHOW: 'shared:advanced-reporting-add-on:show',
  ADVANCED_REPORTING_ADD_ON_SUCCESS: 'shared:advanced-reporting-add-on:success',
};
